import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { SITE_IMAGE_DEFAULTS } from "../data/products";
import { API, resolveImageUrl } from "../lib/api";

export default function useSiteImages() {
  const defaults = useMemo(
    () => Object.fromEntries(SITE_IMAGE_DEFAULTS.map((image) => [image.key, image.url])),
    []
  );
  const [images, setImages] = useState(defaults);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/site-images`);
        if (!mounted || !Array.isArray(data)) return;
        setImages({
          ...defaults,
          ...Object.fromEntries(data.map((image) => [image.key, resolveImageUrl(image.url)])),
        });
      } catch (e) {
        // Keep bundled defaults if the API is unavailable.
      }
    })();
    return () => { mounted = false; };
  }, [defaults]);

  return images;
}
